import { IPropertyEvaluator } from '../../property-evaluator/property-evaluator.interface';
import { IConfigurationEvaluationContext } from '../../configuration-evaluation-context/configuration-evaluation-context.interface';
import { createStatementsDefinition } from '../../../../../../app-react/services/configurations/create-statements-definition'

export class GamesIdPropertyEvaluator implements IPropertyEvaluator {
  constructor(private _owner: any, private _adminConfig: any) {

  }

  get owner(): any {
    return this._owner;
  }

  get adminConfig(): any {
    return this._adminConfig;
  }

  get propertyName(): string {
    return 'gamesId'
  }

  evaluate(context: IConfigurationEvaluationContext): any {
    let propertyContext = context.createPropertyContext(this.propertyName);

    let gamesAdminRefKey = this.owner.gamesAdminRefKey;

    //F TO DO - log if gamesAdminRefKey is missing

    let subLists = this.adminConfig && this.adminConfig.listsv2 && this.adminConfig.listsv2[gamesAdminRefKey];

    let gameTypes: number[] = [];
    if (!subLists) {
      //F TO DO - log if sub-lists is missing
      gameTypes = context.parsePropertyValue(this.owner[this.propertyName]).evaluate(propertyContext);
    } else {
      gameTypes = context.parsePropertyValue(createStatementsDefinition(subLists)).evaluate(propertyContext);
    }

    let launcherGames = context.getLauncherGames() || [];

    if (launcherGames.length === 0) {
      return gameTypes;
    }

    return [...launcherGames, ...gameTypes];
  }
}
